


























































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { searchStudent } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import {
  homeworkDetailListInter,
  getHomeworkDetailListApi,
} from "@/api/homework";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    title: "",
    expireTimeClass: [],
    teacher_id: "",
    teacher_list: [],
  };
  statusList: object[] = [
    {
      status_id: 2,
      name: "未提交",
    },
    {
      status_id: 3,
      name: "待批改",
    },
    {
      status_id: 4,
      name: "已批改",
    },
    {
      status_id: 5,
      name: "已截止",
    },
  ];
  studentNameList: any = [];
  tableData: any = [];
  page = 1;
  pageSize = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total = 5;
  created() {
    this.mixinGetPageInfo("exerciseDetails");
    this.handleStudentNameList("");
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
  }
  handleChange() {
    this.getList({
      page: 1,
      pageSize: this.pageSize,
    });
    this.page = 1;
    this.mixinSavePageInfo("exerciseDetails");
  }
  goHomeWorkDetail(val: any) {
    if (val.status === 3 || val.status === 4) {
      this.$router.push({
        name: "afterDetails",
        query: {
          id: String(val.homework_id),
          h_s_id: String(val.homework_student_id),
          h_id: String(val.homework_id),
          ddl_status: String(val.deadline_status),
        },
      });
    } else {
      this.$router.push({
        name: "afterDetails",
        query: {
          id: String(val.homework_id),
        },
      });
    }
    this.mixinSavePageInfo("exerciseDetails");
  }
  resetSearch() {
    this.searchInfo = {
      title: "",
      expireTimeClass: [],
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
    this.mixinSavePageInfo("exerciseDetails");
  }
  getList(val: { page: number; pageSize: number }) {
    const option: homeworkDetailListInter = {
      page: val.page,
      page_size: val.pageSize,
    };
    if (this.searchInfo.title) {
      option.title = this.searchInfo.title;
    }
    if (this.searchInfo.student_id) {
      option.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.practice_status) {
      option.status = this.searchInfo.practice_status;
    }
    if (this.searchInfo.teacher_id) {
      option.corrected_staff_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.expireTimeClass !== null) {
      option.start_time = this.searchInfo.expireTimeClass[0] / 1000;
      option.end_time =
        (this.searchInfo.expireTimeClass[1] + (24 * 60 * 60 - 1) * 1000) / 1000;
    }
    if (this.searchInfo.sort_type) {
      option.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field) {
      option.sort_field = this.searchInfo.sort_field;
    }
    getHomeworkDetailListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((it: any) => {
          it.publish_time =
            it.publish_time !== 0
              ? dateFormat("YYYY-mm-dd HH:MM", it.publish_time * 1000)
              : "-";
          it.committed_time =
            it.committed_time !== 0
              ? dateFormat("YYYY-mm-dd HH:MM", it.committed_time * 1000)
              : "-";
        });
        this.total = res.data.total;
        this.tableData = res.data.list;
      }
    });
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: this.page,
      pageSize: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      pageSize: this.pageSize,
    });
    this.mixinSavePageInfo("exerciseDetails");
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      pageSize: e,
    });
    this.mixinSavePageInfo("exerciseDetails");
  }
  handleStudentNameList(v: any) {
    searchStudent({
      page: 1,
      page_size: 1000,
      key_word: v,
      status: [2],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentNameList = res.data.list;
      }
    });
  }
}
